import Vue from 'vue'
import Vuex, {createLogger} from 'vuex'
import {createStoreSyncPlugin} from '@/libs/core/realtime/store-sync-plugin';

Vue.use(Vuex)

const storeSyncPlugin = createStoreSyncPlugin();

export default new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',
  plugins: process.env.NODE_ENV === 'development' ? [createLogger(), storeSyncPlugin] : [storeSyncPlugin]
})
